import styled from '@emotion/styled';

// Host container for the embedded <salve-clinic-form-designer> web component.
// Uses min-height (not height) and no overflow rules — Lesson SA-8399: page
// scrolling is owned by .mat-sidenav-content and clipping should be fixed in
// the Angular host, never inside the MFE.
export const FormDefinitionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 480px;
  width: 100%;

  salve-clinic-form-designer {
    display: flex;
    flex: 1;
    width: 100%;
  }
`;
